import { render, staticRenderFns } from "./QuestionComponent.vue?vue&type=template&id=0096f8d5&scoped=true&"
import script from "./QuestionComponent.vue?vue&type=script&lang=js&"
export * from "./QuestionComponent.vue?vue&type=script&lang=js&"
import style0 from "./QuestionComponent.vue?vue&type=style&index=0&id=0096f8d5&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0096f8d5",
  null
  
)

export default component.exports